module.exports = __webpack_public_path__ + "img/temp-bg.91dff059.png";